import React from "react";
import { AgeReadyContext } from "./AgeReadyContext/AgeReadyContext";
import App from "./App";
import AgeReadyAuthenticator from "./Components/Authenticator/AgeReadyAuthenticator";

const AppWithAuth: React.FC = (): React.ReactElement => {
  return (
    <div style={{ minHeight: "100vh" }} data-testid="app">
      <AgeReadyAuthenticator>
        <AgeReadyContext>
          <App />
        </AgeReadyContext>
      </AgeReadyAuthenticator>
    </div>
  );
};

export default AppWithAuth;
